import classNames from 'classnames';
import { FieldProps } from 'formik';
import { FC } from 'react';
import { ILabelTitleSubtitle, LabelTitleSubtitle } from './LabelTitleSubtitle';

export interface IRadioV2 {
  active?: boolean;
  checked: boolean;
  disabled?: boolean;
}
export const RadioV2: FC<IRadioV2> = (props) => {
  const { active, checked, disabled } = props;

  return (
    <div className="relative w-fit">
      <input
        type="radio"
        className="absolute left-0 top-0 h-full w-full opacity-0"
      />
      <div
        className={classNames(
          'relative flex h-4 w-4 flex-col items-center justify-center rounded-full border border-grayv2-200 hover:border-grayv2-700',
          { 'bg-grayv2-700': checked },
          { 'bg-grayv2-300': disabled && checked },
          { 'border-grayv2-900': active },
          { 'border-grayv2-300': disabled },
        )}
      >
        <div
          className={classNames(
            'h-[6px] w-[6px] rounded-full bg-shadesv2-0',
            checked ? 'visible' : 'invisible',
            { visible: active },
          )}
        />
      </div>
    </div>
  );
};

export function buildPropsRadioGroupFormik(fieldProps: FieldProps) {
  const { value, name } = fieldProps.field;
  const { setFieldValue } = fieldProps.form;
  return {
    value,
    name,
    onChange: (value: string) => setFieldValue(name, value),
  };
}

interface IRadioWithLabel {
  labelProps: ILabelTitleSubtitle;
  radioV2Props: IRadioV2;
  disabled?: boolean;
}
export const RadioWithLabel: FC<IRadioWithLabel> = (props) => {
  const { labelProps, radioV2Props, disabled } = props;
  const isDisabled = disabled || radioV2Props.disabled;

  return (
    <label
      className={classNames(
        'flex cursor-pointer space-x-3',
        {
          'pointer-events-none': disabled,
        },
        labelProps.subtitle ? 'items-baseline' : 'items-center',
      )}
    >
      <RadioV2 {...radioV2Props} disabled={isDisabled} />
      <LabelTitleSubtitle {...labelProps} disabled={isDisabled} />
    </label>
  );
};
